import { render, staticRenderFns } from "./Wrapping.vue?vue&type=template&id=29306252"
import script from "./Wrapping.vue?vue&type=script&lang=js"
export * from "./Wrapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports